import { Bus } from "baconjs"

import { valueOf } from "@encoway/c-services-js-client"
import { L10n } from "@encoway/l10n"

import { Events } from "../../constants"
import { Constants } from "./constants"
import { download, getProductInfo } from "./helper"
import {
    IVisualizationExtensionBflatExporter,
    IVisualizationOption,
    IVisualizationServer
} from "./visualizationService.types"

export function generateDXF(
    vis: IVisualizationServer,
    option: IVisualizationOption,
    eventBus: Bus<any>,
    productId: string
) {
    vis.cloud.addPendingEvent(Constants.PendingEvent.CreateDXF)

    generateAndDownloadDXF(vis, option, productId)
        .catch((err) => {
            console.error("Error while creating DXF file", err)
            eventBus.push({
                type: Events.ShowError,
                message: L10n.format("Application.Visualization.DXF.error")
            })
        })
        .finally(() =>
            vis.cloud.removePendingEvent(Constants.PendingEvent.CreateDXF)
        )
}

async function generateAndDownloadDXF(
    vis: IVisualizationServer,
    option: IVisualizationOption,
    productId: string
) {
    const product = await getProductInfo(vis, productId)
    if (!product) {
        return
    }

    const cloud = vis.cloud
    const bflatExporter = (await vis.useExtension(
        Constants.Extension.BflatExporter,
        vis.version,
        cloud.token
    )) as IVisualizationExtensionBflatExporter

    const bflatGroupsCharacteristic = valueOf(
        product,
        Constants.Characteristic.BflatGroups
    )
    const bflatGroups =
        typeof bflatGroupsCharacteristic === "string" &&
        JSON.parse(bflatGroupsCharacteristic)

    const bflats = await bflatExporter.extractStencilPaths(cloud, {
        groups: bflatGroups || option.groups || []
    })

    for (const bflat of bflats) {
        const request = new Request(`${option.baseUrl}/convert`, {
            method: "POST",
            headers: new Headers({
                Accept: "application/dxf",
                "Content-Type": "application/vnd.encoway.bflat",
                Authorization: "Bearer " + cloud.token
            }),
            body: JSON.stringify(bflat)
        })

        const response = await fetch(request)
        if (!response.ok) {
            throw response
        }

        const blob = await response.blob()
        const filename = `${bflat.metadata.title}.dxf`
        download(blob, filename)
    }
}
